import React from "react";
import "./Pagination.css";

function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
}) {
   if (!totalPages) {
  return null;
}
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      // Show all pages if 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      if (currentPage > 3) {
        pages.push("...");
      }

      // Show currentPage -1, currentPage, currentPage +1
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      // Always show last page
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="pagination_wraper">
      <div className="d-flex align-items-center">
        <div>
          <p className="page-size">
            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </p>
        </div>

        <div className="PageSizeChageDropdown">
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {/* <option value={5}>5</option> */}
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>

      <div className="page">
        {/* Previous Button */}
        <div
          className={`page__btn ${currentPage > 1 ? "active" : "disabled"}`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        >
          {!(currentPage === 1) && (
            <img
              className="material-icons left_arrow"
              src={require("./../../../assets/images/arrow.png")}
              alt="prev icon"
            ></img>
          )}
        </div>

        {/* Page Numbers */}

        {getPageNumbers().map((page, index) => (
          <div
            key={index}
            className={`page__numbers
       ${page === currentPage ? "active_page" : ""}
      ${page === "..." ? "disabled" : ""}
      `}
            onClick={() => typeof page === "number" && onPageChange(page)}
          >
            {page}
          </div>
        ))}

        {/* Next Button */}
        <div
          className={`page__btn ${currentPage < totalPages ? "active" : "disabled"}`}
          onClick={() =>
            currentPage < totalPages && onPageChange(currentPage + 1)
          }
        >
          {!(currentPage === totalPages) && (
            <img
              className="material-icons"
              src={require("../../../assets/images/arrow.png")}
              alt="next icon"
            ></img>
          )}
        </div>
      </div>

      {/* <div>
        <p>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </p>
      </div> */}

      {/* <div className="PageSizeChageDropdown">
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div> */}
    </div>
  );
}

export default Pagination;
